import React from "react";
import { Avatar, Box, Stack, Typography } from "@mui/material";

const EducationCard = ({ education }) => (
  <Box className="tactical-border cyber-clip" sx={{ p: { xs: 3, md: 4 }, bgcolor: "rgba(5, 8, 18, 0.85)" }}>
    <Stack direction={{ xs: "column", md: "row" }} spacing={3} alignItems={{ xs: "flex-start", md: "center" }}>
      <Avatar src={education.img} variant="square" sx={{
        width: 64, height: 64, bgcolor: "rgba(0, 240, 255, 0.05)",
        border: "1px solid rgba(0, 240, 255, 0.15)",
        clipPath: "polygon(10px 0, 100% 0, 100% calc(100% - 10px), calc(100% - 10px) 100%, 0 100%, 0 10px)",
      }} />
      <Stack spacing={0.5} flex={1}>
        <Stack direction="row" justifyContent="space-between" alignItems="center">
          <Typography sx={{ fontFamily: "'Inter', sans-serif", fontWeight: 400, fontSize: "1.4rem", color: "#e6e8ec" }}>
            {education.school}
          </Typography>
          <Typography sx={{ fontFamily: "'JetBrains Mono', monospace", fontSize: "0.7rem", color: "#6b7582", letterSpacing: "0.15em" }}>
            [{education.date}]
          </Typography>
        </Stack>
        <Typography sx={{ color: "#00f0ff", fontSize: "0.9rem", fontFamily: "'JetBrains Mono', monospace", letterSpacing: "0.05em" }}>
          @ {education.degree}
        </Typography>
      </Stack>
    </Stack>
    
    <Typography sx={{ color: "#858d99", mt: 3, fontSize: "0.9rem", lineHeight: 1.8 }}>
      {education.desc}  
    </Typography>
    
    {education.grade && (
      <Typography sx={{ color: "#e6e8ec", mt: 2, fontSize: "0.8rem", fontFamily: "'JetBrains Mono', monospace" }}>
        EVALUATION: {education.grade}
      </Typography>
    )}
  </Box>
);

export default EducationCard;
